###*
@ngdoc directive
@name kareo.ui.shared.directives.validation:inputGroup
@element input
@description
Validation
@example
 <example module="kareo.ui.shared.directives.validation.input-group">
 <file name="index.html" >
    <div class="kareo">
      <form name="igForm" novalidate>
        <div class="input-group">
          <label>Name</label>
          <input type="text" name="myName" required="" input-group-input="" ng-model="data.myModel"/>
          <p class="error-message">Name is required</p>
        </div>
        <!-- Alternatively specify input by name on the input-group.
             Useful for third party inputs.
             Only use when input-group-input is not available.
             Requires setting $focused manually
        -->
        <div class="input-group" input-group-input-name="other">
          <label>Other</label>
          <input type="text" name="other" required="" ng-model="data.myModel2"
            ng-focus="igForm.other.$focused=true" ng-blur="igForm.other.$focused=false"
            minlength="2"/>
          <p class="error-message" input-group-error="required">Other is required</p>
          <p class="error-message" input-group-error="minlength">Minimum length is 2</p>
        </div>
      </form>
    </div>
  </file>
</example>
*###

angular.module 'kareo.ui.shared.directives.validation.input-group', [
  'kareo.ui.shared.directives.validation.input-group-error'
]

.controller 'InputGroupController', ["$element", "$attrs", "$scope", (element, attrs, scope) ->
  ctrl = this

  form = null
  input = null
  highRisk = false

  showValidation = ->
    !!( (input.$dirty or (form && form.submitPrevented) ) && !input.$focused)
  showError = ->
    showValidation() && input.$invalid
  showSuccess = ->
    highRisk && showValidation() && input.$valid

  @getInput = -> input

  @setForm = (_form_) ->
    form = _form_

  @setHighRisk = (_highRisk_) ->
    highRisk = _highRisk_

  @setInput = (inputRef) ->
    input = inputRef

    input.showError = showError
    input.showSuccess = showSuccess
    input.showValidation = showValidation

    scope.$watch showError, (newVal) ->
      element.toggleClass "error", !!newVal
    scope.$watch showSuccess, (newVal) ->
      element.toggleClass "success", !!newVal

  return
]


.directive "inputGroup", ->
  restrict: "C",
  require: ['inputGroup', '^?form'],
  controller: 'InputGroupController',
  link:
    post: (scope, element, atts, controllers) ->
      controller = controllers[0]
      form = controllers[1]
      if !form
        return
      if(atts.inputGroupForm)
        form = scope.$eval(atts.inputGroupForm)
      controller.setForm form

      if(atts.highRisk)
        controller.setHighRisk scope.$eval(atts.highRisk)

      # Allow specifying the modelController to use
      # instead of using a child input-group-input
      # Assumes $focused will be handled independently
      # Useful for integrating with third party component
      if(atts.inputGroupInputName)
        scope.$watch ->
          form[atts.inputGroupInputName]
        , (ngModelController) ->
          controller.setInput(ngModelController) if ngModelController

.directive "inputGroupInput", ->
  require: ["ngModel", '^inputGroup'],
  compile: ($element, attr) ->
    (scope, element, attrs, controllers) ->
      ngModel = controllers[0]
      controllers[1].setInput ngModel
      element.on "blur", (event) ->
        scope.$evalAsync ->
          ngModel.$focused = false

      element.on "focus", (event) ->
        scope.$evalAsync ->
          ngModel.$focused = true

# backwards compatibility
angular.module 'kareo.ui.shared.directives.input-group', [
  'kareo.ui.shared.directives.validation.input-group'
]